import type {
  Response,
  ExecutiveBySquadResponse,
} from '@/lib/apollo/query/getExecutivesBySquad/query'

import type { TransformedExecutiveBySquadData, TransformedData } from './types'

export const toTransformedExecutiveData = (
  executive: ExecutiveBySquadResponse,
): TransformedExecutiveBySquadData => ({
  ...executive,
  skillLevel: executive.skillLevel ?? undefined,
})

export const toTransformedData = (response?: Response): TransformedData | undefined =>
  response === undefined
    ? undefined
    : {
        ...response.getExecutivesBySquad,
        results: response.getExecutivesBySquad.results.map(toTransformedExecutiveData),
      }
